module.exports = __webpack_public_path__ + "static/img/xi.aa012c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi.jpg
// module id = wqZX
// module chunks = 1